import React, { useEffect } from 'react';
import { RouteComponentProps } from '@reach/router';
import { PanelContent } from '../../components/panel-content';
import { useStateValue } from '../../components/state';
import { Timeline } from '../../components/timeline';
import { LineGraph } from '../../components/line-graph';
import { Button } from '../../components/button';
import { timelineContent } from '../../data/timeline';
import { FactGroup } from '../../components/fact-group';

export const Why: React.FC<RouteComponentProps> = () => {
  const [state, dispatch] = useStateValue();

  // Filter map pins to all
  useEffect(() => {
    dispatch({ type: 'setActiveMarkerSet', payload: { activeMarkerSet: 'default' } });
    dispatch({ type: 'setActiveMarkerType', payload: { activeMarkerType: 'all' } });
    dispatch({ type: 'setSidePanelFull', payload: { sidePanelFull: false } });
  }, [dispatch]);

  const onYearChange = (activeYear: { value: number; label: string }) => {
    dispatch({ type: 'setActiveYear', payload: { activeYear: activeYear.value } });

    // Tracking
    window.digitalData.tool.name = 'PWS Timeline';
    window.digitalData.tool.step = activeYear.label;
    window.digitalData.tool.markerType = '';
    window.dataLayer.push({
      event: 'timelineSliderInteraction',
    });
  };

  const timelineItem = timelineContent.find(item => item.year === state.map.activeYear);

  return (
    <>
      <PanelContent>
        <h1>How our water sources have changed over time</h1>
        <p>
          Climate change is having a profound impact on our water supply. Hotter summers and lower rainfall means we
          must plan for our future by securing climate-resilient water sources.{' '}
        </p>
        <Timeline
          years={[
            { value: 1960, label: `1960's` },
            { value: 1980, label: `1980's` },
            { value: 2007, label: `2000's` },
            { value: 2025, label: 'Now' },
            { value: 2035, label: '2035' },
          ]}
          value={state.map.activeYear}
          onChange={onYearChange}
        />
        {timelineItem && (
          <>
            <p className="timeline-info">{timelineItem.content}</p>
            <LineGraph data={timelineItem.data} color="blue" />
            <LineGraph data={timelineItem.sourceData} />
            <FactGroup data={timelineItem.facts} />
          </>
        )}
        <Button href="https://www.watercorporation.com.au/our-water/perths-water-supply/how-our-water-sources-have-changed">How water is used in your home</Button>
      </PanelContent>
    </>
  );
};
